import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/login/login.vue')
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    meta: {
      title: '登录'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/login/loginPage.vue')
  },
  {
    path: '/welinkBind',
    name: 'welinkBind',
    meta: {
      title: 'welink绑定'
    },
    component: () => import( /* webpackChunkName: "welinkBind" */ '../views/modules/login/welinkBind.vue')
  },
  {
    path: '/welinkCode',
    name: 'welinkCode',
    meta: {
      title: 'welink扫码'
    },
    component: () => import( /* webpackChunkName: "welinkCode" */ '../views/modules/login/welinkCode.vue')
  },
  {
    path: '/course/home/:id',
    name: 'courseHome',
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/textbook/course.vue')
  },
  {
    path: '/courseDeclaration',
    name: 'courseDeclaration',
    meta: {
      title: '课程申报'
    },
    component: () => import(/* webpackChunkName: "courseDeclaration" */ '../views/modules/textbook/courseDeclaration.vue')
  },
  {
    path: '/term/manager',
    name: 'termManager',
    meta: {
      title: '版本与学期'
    },
    component: () => import(/* webpackChunkName: "termManager" */ '../views/modules/textbook/termManager.vue')
  },
  {
    path: '/courseFile',
    name: 'courseFile',
    meta: {
      title: '课程档案'
    },
    component: () => import(/* webpackChunkName: "courseFile" */ '../views/modules/course/courseFile.vue')
  },
  {
    path: '/teaCourseFile',
    name: 'teaCourseFile',
    meta: {
      title: '教学资料'
    },
    component: () => import(/* webpackChunkName: "teaCourseFile" */ '../views/modules/course/teaCourseFile.vue')
  },
  {
    path: '/virtual/grade',
    name: 'virtualGrade',
    meta: {
      title: '实验成绩'
    },
    component: () => import(/* webpackChunkName: "virtualGrade" */ '../views/modules/virtual/grade.vue')
  },{
    path: '/virtual/experiment/detail',
    name: 'experimentDetail',
    meta: {
      title: '实验步骤成绩详情'
    },
    component: () => import(/* webpackChunkName: "virtualGrade" */ '../views/modules/virtual/experimentDetail.vue')
  },
  {
    path: '/virtual/home/:id',
    name: 'virtualHome',
    meta: {
      title: '实验主页'
    },
    component: () => import(/* webpackChunkName: "virtualGrade" */ '../views/modules/virtual/home.vue')
  },
  {
    path: '/virtual/courseList',
    name: 'virtualCourseList',
    meta: {
      title: 'AI实验'
    },
    component: () => import(/* webpackChunkName: "virtualCourseList" */ '../views/modules/virtual/courseList/index.vue')
  },
  {
    path: '/virtual/homePage/:id/:router',
    name: 'virtualHomePage',
    meta: {
      title: 'AI实验'
    },
    component: () => import(/* webpackChunkName: "virtualHomePage" */ '../views/modules/virtual/homePage/index.vue')
  },
  {
    path: '/virtual/coursePage/:id',
    name: 'coursePage',
    meta: {
      title: 'AI实验'
    },
    component: () => import(/* webpackChunkName: "coursePage" */ '../views/modules/virtual/coursePage/index.vue')
  },
  {
    path: '/virtual/experimentPage/:id',
    name: 'experimentPage',
    meta: {
      title: 'AI实验'
    },
    component: () => import(/* webpackChunkName: "experimentPage" */ '../views/modules/virtual/experimentPage/index.vue')
  },
  {
    path: '/scanSignature',
    name: 'scanSignature',
    meta: {
      title: '签名'
    },
    component: () => import(/* webpackChunkName: "scanSignature" */ '../views/modules/scanSignature/index.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

export default router
